import React from 'react'
import Table from './Table'
import { Box } from '@material-ui/core'

export default function Students() {
  return (
    <Box>
      <h1>Students</h1>
      <Table />
    </Box>
  )
}
